/** saves tpa types
@payload { Object } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_tpaRequesttpatypes
*/
export const SAVE_AVAILABLE_TPAS_TYPES = (state, payload) => {
    state.tpasTypes = payload.tpaTypes
}

/** saves Accounts Balances
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
*/
export const SAVE_ACCOUNTS_BALANCE = (state, payload) => {
    state.accountsBalances = payload.balanceViews
}

/** saves Company Data
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_tpaRequestcompanyData?parent=Web_API
*/
export const SAVE_COMPANY_DATA = (state, payload) => {
    state.companyData = payload
}

/** saves Locations
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetlocation
*/
export const SAVE_LOCATIONS = (state, payload) => {
    state.locations = payload.locations
}

/** saves agencies provinces
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_agenciesprovinces
*/
export const SAVE_AGENCIES_PROVINCES = (state, payload) => {
    state.agenciesProvinces = payload.provinces
}

/** saves branches
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_branches
*/
export const SAVE_BRANCHES = (state, payload) => {
    state.branches = payload.page
}

/** saves economic activities
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_tpaRequestLovseconomicActivities
*/
export const SAVE_ECONOMIC_ACTIVITIES = (state, payload) => {
    state.economicActivities = payload.tpaEconomicActivityList
}

/** saves authorized operations
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_tpaRequestLovsauthorizedOperations
*/
export const SAVE_AUTHORIZED_OPERATIONS = (state, payload) => {
    state.authorizedOperations = payload.tpaAuthorizedOperationsList
}

/** saves accepted cards
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_tpaRequestLovsauthorizedOperations
*/
export const SAVE_ACCEPTED_CARDS = (state, payload) => {
    state.acceptedCards = payload.tpaCardTypeList
}

/** Clears feature states */
export const CLEAR_REQUEST_TPAS_BAI_FEATURE_STATE = (state, payload) => {
    state.accountsBalances = []
    state.companyData = {}
    state.locations = []
    state.agenciesProvinces = []
    state.branches = []
    state.economicActivities = []
    state.authorizedOperations = []
    state.acceptedCards = []
}
